<template>
  <div
    class="w-full bg-white d-flex flex-wrap"
    style="padding-left: 1em; padding-right: 1em"
  >
    <h5 class="w-full text-left mt-4" style="border-bottom: 3px solid #344c8b">
      DATOS DE PAGARÉ
    </h5>
    <v-radio-group v-if="isPR" v-model="form.is_promissory_note" row>
      <template #label>
        <div>Seleccione una opción</div>
      </template>
      <v-radio color="error" label="Pagaré" :value="1" />
      <v-radio color="error" label="Carta no pagaré" :value="0" />
    </v-radio-group>

    <template v-if="loading">
      <v-progress-circular indeterminate color="primary" />
    </template>
    <v-form
      v-else
      ref="customerRequestForm"
      v-model="form.valid"
      lazy-validation
    >
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <span> Nombre del aval*: </span>
          <v-text-field
            ref="bank_guarantee_name"
            v-model="form.bank_guarantee_name"
            label="Nombre completo"
            :rules="[bankGuaranteeNameRules]"
            :disabled="!isPromissoryNoteRequest"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <input-date-picker
            v-model="form.promissory_note_date"
            label="fecha de firma de pagaré*"
            label-class="d-flex flex-column text-muted font-weight-bold"
            :max-date="new Date()"
            errors="Colocar fecha del pagaré"
            required
          />
          <!-- Hidden field used to integrate date validation into v-form -->
          <v-text-field
            ref="promissory_note_date"
            v-model="form.promissory_note_date"
            style="display: none"
            :rules="[requiredRule]"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="form.credit_line_amount_requested"
            :disabled="form.is_update ? true : false"
            prefix="$"
            type="number"
            step="1000"
            :label="`
            ${
              form.credit_line_amount_requested
                ? `Monto de línea de crédito* ${formatNumber(
                    form.credit_line_amount_requested,
                    '$',
                    0
                  )}`
                : ''
            }`"
            persistent-hint
            :hint="`Monto actual de línea de crédito: ${formatNumber(
              customerInfo.creditAmount ?? 0,
              '$',
              0
            )}`"
            :rules="[creditAmountRules]"
            filled
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-radio-group v-model="form.tax_regime" row>
            <template #label>
              <div>Regimen fiscal</div>
            </template>
            <v-radio
              color="warning"
              :label="taxRegimes.INDIVIDUAL.text"
              :value="taxRegimes.INDIVIDUAL.value"
            />
            <v-radio
              color="warning"
              :label="taxRegimes.COORPORATE.text"
              :value="taxRegimes.COORPORATE.value"
            />
          </v-radio-group>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-radio-group v-model="form.is_update" row>
            <template #label>
              <div>Solicitud*</div>
            </template>
            <v-radio color="warning" label="Actualización" :value="1" />
            <v-radio
              color="warning"
              label="Incremento de línea de crédito"
              :value="0"
              :disabled="!isPromissoryNoteRequest"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            ref="promissory_note_amount"
            v-model="form.promissory_note_amount"
            type="number"
            prefix="$"
            filled
            label="Monto de pagaré*"
            persistent-hint
            step="100"
            :rules="[promissoryNoteAmountRules]"
            :disabled="!isPromissoryNoteRequest"
            :hint="`Monto de
        pagaré: ${formatNumber(form.promissory_note_amount ?? 0, '$', 0)}`"
          />
        </v-col>
        <v-col v-if="editMode" cols="12">
          <v-chip class="ma-2" color="red" text-color="white">
            <v-icon>mdi-alert</v-icon> Si existe un error en algun documento;
            Solo cargar los documentos que se necesiten corregir
          </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <template v-for="(item, index) in docs">
          <v-col
            v-if="requiredDocs[item.value]"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            class="d-flex flex-row"
          >
            <v-btn
              v-if="editMode"
              target="_blank"
              :href="promissoryNote.files[item.value]"
              icon
            >
              <v-icon :color="item.color">mdi-file</v-icon>
            </v-btn>

            <file-input
              :key="item.value"
              :ref="`doc_${item.value}`"
              v-model="form[item.value]"
              :label="item.text"
              accept="application/pdf"
              :required="true"
              :max-size-mb="5"
            />
          </v-col>
        </template>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-secondary text-left">
            <v-icon>mdi-information</v-icon>
            **Ingrese en formato
            <strong>PDF</strong> los documentos originales** *campos
            obligatorios No mayor a dos meses de emision</span
          >
        </v-col>
        <v-col cols="12">
          <label for="" class="w-full text-left font-weight-black mb-1"
            >Comentarios*:</label
          >
          <v-textarea
            v-model="form.comment"
            solo
            class="comments"
            :rules="[requiredRule]"
          />
        </v-col>
      </v-row>
    </v-form>
    <div class="w-full text-center ma-2">
      <v-btn :loading="loading" class="ma-1" @click="cancel">Cancelar</v-btn>
      <v-btn
        v-if="editMode"
        :loading="loading"
        class="ma-1"
        color="warning"
        @click="update"
        >Actualizar</v-btn
      >
      <v-btn
        v-else
        class="ma-1"
        color="success"
        :loading="loading"
        @click="send"
        >Enviar</v-btn
      >
    </div>
  </div>
</template>

<script>
  import axios from '@/plugins/axios';
  import moment from 'moment';
  import numbersFormats from '@/mixins/numbersFormats';
  import { requiredFields } from './utilities/promissoryNoteRequeriments';
  import { DOCUMENTS } from './constants/requerimentDocuments';
  import { TAX_REGIMES } from '@/core/constants/taxRegimes';
  import { Channels } from '@/core/constants/channelConstants';
  import { MIN_AMOUNT_PROMISSORY_NOTE_DT } from '@/core/constants/promissoryNoteApplication';
  import InputDatePicker from '@/components/InputDatePicker.vue';
  import FileInput from '@/components/buttons/FileInput.vue';

  export default {
    name: 'PromissoryNoteForm',
    components: { InputDatePicker, FileInput },
    mixins: [numbersFormats],
    props: {
      customerInfo: {
        type: Object,
        required: true,
        default: () => ({
          userId: '',
          customerId: '',
          channel: '',
          creditAmount: 0,
          promissoryNoteAmount: 0,
          promissoryNoteDate: null,
          bankGuaranteeName: '',
        }),
      },
      editMode: {
        type: Boolean,
        required: true,
      },
      promissoryNote: {
        type: Object,
        default: () => ({}),
      },
    },
    data: () => ({
      form: {
        promissory_note: null,
        comment: 'Sin comentarios',
        tax_regime: null,
        is_update: 1,
        credit_line_amount_requested: 0,
        credit_line: 0,
        promissory_note_amount: 0,
        promissory_note_date: '',
        bank_guarantee_name: '',
        valid: false,
        user_id: '',
        is_promissory_note: 1,
      },
      loading: false,
      today: '',
    }),
    computed: {
      isPromissoryNoteRequest() {
        return this.form.is_promissory_note;
      },
      bankGuaranteeNameRules() {
        return (value) => {
          if (!this.isPromissoryNoteRequest) {
            return true;
          }
          if (
            this.form.credit_line_amount_requested <
              MIN_AMOUNT_PROMISSORY_NOTE_DT &&
            this.form.promissory_note_amount <= MIN_AMOUNT_PROMISSORY_NOTE_DT &&
            !this.isPR
          ) {
            return true;
          }
          if (!value) return 'Este campo es requerido';
          return true;
        };
      },
      isPR() {
        return this.customerInfo.channel === Channels.WHOLESALER;
      },
      taxRegimes() {
        return TAX_REGIMES;
      },
      docs() {
        return DOCUMENTS;
      },
      requiredDocs() {
        return requiredFields(this.creditContext);
      },
      creditContext() {
        return {
          channel: this.customerInfo.channel,
          isUpdate: this.form.is_update,
          isIncrease: !this.form.is_update,
          taxRegime: this.form.tax_regime,
          creditLineAmount: this.form.credit_line_amount_requested,
          promissoryNoteAmount: this.form.promissory_note_amount,
          isPromissoryNote: this.form.is_promissory_note,
        };
      },
      requiredRule() {
        return (v) => !!v || 'El campo es requerido';
      },
      creditAmountRules() {
        return (v) => {
          const creditLimit = Number(v);
          if (creditLimit <= 0 || isNaN(creditLimit)) {
            return 'El monto es requerido';
          }
          if (!this.isPromissoryNoteRequest) {
            if (creditLimit < this.customerInfo.creditAmount) {
              return 'El monto de línea de crédito debe ser mayor al monto actual';
            }
            return true;
          }
          if (this.form.is_update) return true;
          if (this.customerInfo.creditAmount >= creditLimit) {
            return 'El incremento de crédito debe ser mayor al credito actual';
          }
          return true;
        };
      },
      promissoryNoteAmountRules() {
        return (v) => {
          if (!this.isPromissoryNoteRequest) {
            return true;
          }
          const promissory = Number(v);
          const creditLimit = Number(this.form.credit_line_amount_requested);
          if (promissory <= 0 || isNaN(promissory)) {
            return 'El monto es requerido';
          }
          if (this.isPR) {
            if (promissory < creditLimit * 2) {
              return 'El monto del pagaré no puede ser menor al doble de la línea de crédito';
            }
          }
          if (promissory < creditLimit) {
            return 'El monto del pagaré debe ser mayor o igual a la línea de crédito';
          }
          return true;
        };
      },
    },
    watch: {
      'form.is_promissory_note': function (value) {
        this.form.credit_line_amount_requested =
          this.customerInfo.creditAmount || 0;
        this.form.bank_guarantee_name = value
          ? this.customerInfo.bankGuaranteeName
          : '';
        this.form.is_update = 1;
        this.form.promissory_note_amount = 0;
        this.$refs.customerRequestForm.resetValidation();
      },
      'form.credit_line_amount_requested'() {
        this.$refs.promissory_note_amount?.validate();
        this.$refs.bank_guarantee_name?.validate();
      },
      'form.is_update': function () {
        this.form.credit_line_amount_requested =
          this.customerInfo.creditAmount || 0;
        this.$refs.bank_guarantee_name?.validate();
      },
      'form.promissory_note_amount': function (newVal) {
        if (isNaN(newVal)) {
          this.form.promissory_note_amount = 0;
        }
        this.$refs.promissory_note_amount.validate();
        this.$refs.bank_guarantee_name.validate();
      },
    },
    mounted() {
      this.today = moment().format('YYYY-MM-DD');
      this.setFormConfig();
    },
    methods: {
      setFormConfig() {
        this.editMode ? this.setForm(this.promissoryNote) : this.initForm();
      },
      async update() {
        if (!this.validateForm()) return;
        const form = this.prepareForm();
        this.loading = true;
        try {
          await axios.post(
            `/promissory-notes/requests/update/${this.promissoryNote.id}`,
            form,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );
          this.$swal({
            title: 'Enviado a validación con el gerente',
            type: 'success',
          });
          this.cancel();
          this.$emit('requestSubmitted');
        } catch (error) {
          this.$swal({
            title: 'Ocurrio un error al enviar la solicitud',
            text: error,
            type: 'warning',
          });
        }
        this.loading = false;
      },
      formatDate(date) {
        if (!date) return '';
        return moment(date).format('YYYY-MM-DD');
      },
      validateFiles() {
        let filesValid = true;
        for (const key in this.requiredDocs) {
          let ref = this.$refs[`doc_${key}`];
          const anyValid = ref.some((r) => {
            return r.validate();
          });
          if (!anyValid) filesValid = false;
        }
        return filesValid;
      },
      validateForm(withFiles = false) {
        const formValid = this.$refs.customerRequestForm.validate();
        const filesValid = withFiles ? this.validateFiles() : true;

        if (!formValid || !filesValid) {
          this.$swal.fire({
            title: 'Existen errores en el formulario',
            text: 'Por favor corrija los errores antes de enviar',
            icon: 'warning',
          });
          return false;
        }
        return true;
      },
      send() {
        if (!this.validateForm(true)) return;
        this.$swal
          .fire({
            title: 'Confirmar el envío del Pagaré',
            icon: 'warning',
            showCancelButton: true,
            confirmButton: '#66BB6A',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Enviar',
          })
          .then((result) => {
            if (result.value) {
              this.fetchCustomerDocs();
            }
          });
      },
      prepareForm() {
        let formData = new FormData();
        formData.append(
          'request_type',
          this.form.is_update ? 'update' : 'increase'
        );
        if (this.editMode) {
          formData.append('_method', 'PUT');
          formData.append('status', 'VOM');
        }
        Object.keys(this.form).forEach((key) => {
          if (key === 'promissory_note_date') {
            formData.append(key, this.formatDate(this.form[key]));
          } else {
            this.form[key] instanceof File
              ? formData.append(`documents[${key}]`, this.form[key])
              : formData.append(key, this.form[key]);
          }
        });
        return formData;
      },
      async fetchCustomerDocs() {
        const form = this.prepareForm();
        this.loading = true;
        try {
          await axios.post('/promissory-notes/requests', form);
          this.$swal({
            title: 'Enviado a validación con el gerente',
            type: 'success',
          });
          this.$emit('requestSubmitted');
        } catch (error) {
          this.$swal({
            title: 'Ocurrio un error al enviar la solicitud',
            text: error,
            type: 'warning',
          });
        }
        this.loading = false;
      },
      cancel() {
        this.$emit('cancel');
      },
      setForm(value) {
        this.form.bank_guarantee_name = value.bank_guarantee_name_2 ?? '';
        this.form.tax_regime = value.taxRegime;
        this.form.channel = this.customerInfo.channel;
        this.form.credit_line = value.credit_line;
        this.form.customer_id = value.customer_id;
        this.form.user_id = value.customer_id;
        this.form.credit_line_amount_requested =
          value.credit_line_amount_requested;
        this.form.promissory_note_amount = value.promissory_note_amount;
        this.form.promissory_note_date = moment(
          value.promissory_note_date,
          'DD-MM-YYYY'
        ).format('YYYY-MM-DD');
        this.form.is_update =
          value.request_type.status_code == 'update' ? 1 : 0;
        this.form.is_promissory_note = value.is_promissory_note ?? 1;
      },
      initForm() {
        this.form.promissory_note_date = this.customerInfo.promissoryNoteDate
          ? moment(this.customerInfo.promissoryNoteDate).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD');
        this.customerInfo.promissoryNoteDate;
        this.form.bank_guarantee_name =
          this.customerInfo.bankGuaranteeName ?? '';
        this.form.tax_regime = TAX_REGIMES.INDIVIDUAL.value;
        this.form.channel = this.customerInfo.channel;
        this.form.credit_line = this.customerInfo.creditAmount;
        this.form.customer_id = this.customerInfo.customerId;
        this.form.user_id = this.customerInfo.userId;
        this.form.credit_line_amount_requested =
          Number(this.customerInfo.creditAmount) || 0;

        this.form.promissory_note_amount =
          Number(this.customerInfo.promissoryNoteAmount) || 0;
      },
    },
  };
</script>
